export enum TipoConferenciaEnum {
  Cega = 1,
  Aberta = 2,
}
